/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".start-button[_ngcontent-%COMP%]{font-family:HelveticaNeue-Light,\"Helvetica Neue Light\",\"Helvetica Neue\",Helvetica,Arial,\"Lucida Grande\",sans-serif;letter-spacing:1px;background-color:#3a9af9;border-radius:28px;width:100%;line-height:44px;height:56px;font-size:18px;font-weight:400;color:#fff!important}\n/*# sourceMappingURL=retry-button.component.css.map*/"];
export { styles as styles };
